const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  isFrom: null,
  preAuthId: "",
  subClaimType: "",
  subClaimServiceTypeId: "",
  createAuthSubClaimData: {},
  authScreenData: {},
  isAbleToApprove: true,
  partsDetailData: "",
  isAddPartDetail: null,
};
const serviceOrderDetailSlice = createSlice({
  name: "serviceOrderDetail",
  initialState,
  reducers: {
    saveIsFromDetails: (state, action) => {
      state.isFrom = action.payload;
    },
    savePreAuthId: (state, action) => {
      state.preAuthId = action.payload;
    },
    saveSubClaimType: (state, action) => {
      state.subClaimType = action.payload;
    },
    saveSubClaimServiceTypeId: (state, action) => {
      state.subClaimServiceTypeId = action.payload;
    },
    saveCreateAuthSubClaim: (state, action) => {
      state.createAuthSubClaimData = action.payload;
    },
    saveAuthScreenData: (state, action) => {
      state.authScreenData = action.payload;
    },
    saveHandleApproveBtn: (state, action) => {
      state.isAbleToApprove = action.payload;
    },
    savePartsDetailData: (state, action) => {
      state.partsDetailData = action.payload;
    },
    savePartsDetails: (state, action) => {
      state.isAddPartDetail = action.payload;
    },

    reset: () => initialState,
  },
});
export const {
  saveIsFromDetails,
  savePreAuthId,
  saveSubClaimType,
  saveSubClaimServiceTypeId,
  saveCreateAuthSubClaim,
  saveAuthScreenData,
  reset,
  saveHandleApproveBtn,
  savePartsDetailData,
  savePartsDetails,
} = serviceOrderDetailSlice.actions;
export default serviceOrderDetailSlice.reducer;
